// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3287":"27747b595a88db3e","7712":"48d1b839cdfe2c03"}[chunkId] + ".js";
};